import { render, staticRenderFns } from "./TaskTheme.vue?vue&type=template&id=79996bee&scoped=true"
import script from "./TaskTheme.vue?vue&type=script&lang=js"
export * from "./TaskTheme.vue?vue&type=script&lang=js"
import style0 from "./TaskTheme.vue?vue&type=style&index=0&id=79996bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79996bee",
  null
  
)

export default component.exports